import { ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import TplForSelect from '../entities/tpls/tplForSelect';

interface TimeAllowsWarrantyActivateConfigState extends ListState<any>{
    tplsForSelect: TplForSelect[],
    typeForSelect : [],
    listSelect: Array<any>,
}
class TimeAllowsWarrantyActivateConfigModule extends ListModule<TimeAllowsWarrantyActivateConfigState,any,any>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<any>(),
        listSelect: new Array<any>(),
        loading:false,
        tplsForSelect : new Array<TplForSelect>(),
        typeForSelect:[],
    }
    actions={
        async getAll(context:ActionContext<TimeAllowsWarrantyActivateConfigState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TimeAllowsWarrantyActivateConfig',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<any>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getAllSelect(context:ActionContext<TimeAllowsWarrantyActivateConfigState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TimeAllowsWarrantyActivateConfig',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<any>;
            context.state.totalCount=page.totalCount;
            context.state.listSelect = page.items;
        },
        async get(context:ActionContext<TimeAllowsWarrantyActivateConfigState,any>,payload:any){
            let reponse=await Ajax.get(`/api/services/app/Profile/${payload.data.id}/info`);
            return reponse.data.result;
        },
        async getListForSelect(context: ActionContext<TimeAllowsWarrantyActivateConfigState, any>,payload:any) {
            let reponse = await Ajax.get('/api/services/app/tpl/GetTpls',{ params : payload.data });
            context.state.tplsForSelect = reponse.data.result as TplForSelect[];
        },
        async getTypesForSelect(context: ActionContext<TimeAllowsWarrantyActivateConfigState, any>,payload:any) {
            let reponse = await Ajax.get('/api/services/app/tpl/types');
            context.state.typeForSelect = reponse.data.result
           return reponse.data.result ;
        },
        async searchTplForSelect(context:ActionContext<TimeAllowsWarrantyActivateConfigState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/Tpl/SearchTplForSelect/'+payload.data);
            return result.items  as TplForSelect[];
        },
        async create(context: ActionContext<TimeAllowsWarrantyActivateConfigState, any>, payload: any) {
            await Ajax.post('/api/services/app/Profile', payload.data);
        },
        async update(context: ActionContext<TimeAllowsWarrantyActivateConfigState, any>, payload: any) {
            await Ajax.put('/api/services/app/Profile', payload.data);
        },
        async switchState(context: ActionContext<TimeAllowsWarrantyActivateConfigState, any>, payload: any) {
            await Ajax.put('/api/services/app/tpl/SwitchState?id=' + payload.data.id , {});
        }
    };
    mutations={
        setCurrentPage(state:TimeAllowsWarrantyActivateConfigState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:TimeAllowsWarrantyActivateConfigState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const timeAllowsWarrantyActivateConfigModule = new TimeAllowsWarrantyActivateConfigModule();
export default timeAllowsWarrantyActivateConfigModule;